import Vue from 'vue';
import Router from 'vue-router';
import Question from '../components/page/Question';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: { title: '自述文件' },
            children:[
                {
                    path: '/dashboard',
                    component: resolve => require(['../components/page/Dashboard.vue'], resolve),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/user',
                    component: resolve => require(['../components/page/User.vue'], resolve),
                    meta: { title: '学员管理' }
                },
                {
                    path: '/exception',
                    component: resolve => require(['../components/page/ImportException.vue'], resolve),
                    meta: { title: '学员导入异常' }
                },
                {
                    path: '/record',
                    component: resolve => require(['../components/page/Record.vue'], resolve),
                    meta: { title: '考试记录' }
                },
                {
                    path: '/certificate',
                    component: resolve => require(['../components/page/Certificate.vue'], resolve),
                    meta: { title: '证书管理' }
                },
                {
                    path: '/cpe',
                    component: resolve => require(['../components/page/Cpe.vue'], resolve),
                    meta: { title: 'CPE管理' }
                },
                {
                    path: '/subject',
                    component: resolve => require(['../components/page/Subject.vue'], resolve),
                    meta: { title: '科目管理' }
                },
                {
                    path: '/appointment',
                    component: resolve => require(['../components/page/Appoinitment.vue'], resolve),
                    meta: { title: '预约管理' }
                },
                {
                    path: '/question',
                    component: resolve => require(['../components/page/Question.vue'], resolve),
                    meta: { title: '题库管理' }
                },
                {
                    path: '/order',
                    component: resolve => require(['../components/page/Order.vue'], resolve),
                    meta: { title: '订单管理' }
                },
                {
                    path: '/orderException',
                    component: resolve => require(['../components/page/OrderException.vue'], resolve),
                    meta: { title: '异常日志' }
                },
                {
                    path: '/carousel',
                    component: resolve => require(['../components/page/Carousel.vue'], resolve),
                    meta: { title: '轮播图' }
                },
                {
                    path: '/systemConfig',
                    component: resolve => require(['../components/page/SystemConfig.vue'], resolve),
                    meta: { title: '系统设置' }
                },
                {
                    path: '/table',
                    component: resolve => require(['../components/page/BaseTable.vue'], resolve),
                    meta: { title: '基础表格' }
                },
                {
                    path: '/tabs',
                    component: resolve => require(['../components/page/Tabs.vue'], resolve),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: '/form',
                    component: resolve => require(['../components/page/BaseForm.vue'], resolve),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: '/editor',
                    component: resolve => require(['../components/page/VueEditor.vue'], resolve),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: '/markdown',
                    component: resolve => require(['../components/page/Markdown.vue'], resolve),
                    meta: { title: 'markdown编辑器' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: resolve => require(['../components/page/Upload.vue'], resolve),
                    meta: { title: '文件上传' }
                },
                {
                    // vue-schart组件
                    path: '/charts',
                    component: resolve => require(['../components/page/BaseCharts.vue'], resolve),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: '/drag',
                    component: resolve => require(['../components/page/DragList.vue'], resolve),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: resolve => require(['../components/page/Permission.vue'], resolve),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    // 修改密码
                    path: '/updatePassword',
                    component: resolve => require(['../components/page/UpdatePassword.vue'], resolve),
                    meta: { title: '修改密码'}
                },{
                    // 修改密码
                    path: '/cpeActivity',
                    component: resolve => require(['../components/page/CpeActivity.vue'], resolve),
                    meta: { title: 'CPE活动'}
                },
                {
                    // 修改密码
                    path: '/cpePolicy',
                    component: resolve => require(['../components/page/CpePolicy.vue'], resolve),
                    meta: { title: '证书维持政策'}
                },
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/Login.vue'], resolve)
        },
        {
            path: '/404',
            component: resolve => require(['../components/404.vue'], resolve)
        },
        {
            path: '/403',
            component: resolve => require(['../components/403.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})
